var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.297,
    height: 77.296,
    viewBox: "0 0 77.297 77.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 77.297,
    height: 77.296,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M77.3,38.649A38.648,38.648,0,1,1,38.648,0,38.65,38.65,0,0,1,77.3,38.649",
    transform: "translate(0.002 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M42.511,55.837H32.536a1.353,1.353,0,0,1-1.352-1.352v-9.2h-6.97v9.2a1.353,1.353,0,0,1-1.352,1.352H12.887a1.351,1.351,0,0,1-1.349-1.352V37.069h-5.6a1.35,1.35,0,0,1-.964-2.3L26.735,12.558a1.385,1.385,0,0,1,1.928,0l8.891,9.073c.073-4.236,1.365-7.288,3.861-9.1,5.939-4.314,16.292.423,16.73.628a1.351,1.351,0,0,1-.333,2.554c.043,0-1.324.576-3.52,4.239a12.778,12.778,0,0,1-11.63,6.9l7.766,7.929a1.35,1.35,0,0,1-.964,2.3h-5.6V54.485a1.352,1.352,0,0,1-1.349,1.352m-8.625-2.7h7.273V35.717a1.352,1.352,0,0,1,1.352-1.349h3.738L38.43,26.388c-.043-.028-.085-.055-.128-.085v0a1.331,1.331,0,0,1-.376-.428L27.7,15.432,9.149,34.367h3.738a1.352,1.352,0,0,1,1.352,1.349V53.135h7.273v-9.2a1.351,1.351,0,0,1,1.349-1.352h9.674a1.351,1.351,0,0,1,1.349,1.352Zm7.629-29.013c4.785.24,8.222-1.58,10.44-5.531a21,21,0,0,1,2.839-3.846C51.74,13.7,46.247,12.355,43,14.716c-1.713,1.247-2.626,3.463-2.739,6.61,2.108-2.606,4.887-5.158,8.392-6.031a1.35,1.35,0,0,1,.651,2.621c-3.247.809-5.869,3.6-7.789,6.207m-5.045-5.7h-.038a1.349,1.349,0,0,1-1.312-1.387A11.258,11.258,0,0,1,36.4,11.887a1.351,1.351,0,0,1,2.369,1.3,8.616,8.616,0,0,0-.951,3.923,1.351,1.351,0,0,1-1.349,1.314M33.488,14.11a1.35,1.35,0,0,1-1.144-2.068c2.449-3.908,7.514-6.439,7.729-6.547A1.352,1.352,0,0,1,41.86,7.348a7.449,7.449,0,0,0,.393,2.616,1.351,1.351,0,0,1-2.6.729,14.368,14.368,0,0,1-.361-1.607,15.842,15.842,0,0,0-4.657,4.391,1.357,1.357,0,0,1-1.147.633",
    transform: "translate(6.894 8.051)",
    fill: "#eaff50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.3364dd8e17fabef6cfe84fe998dc35f6.svg";
export { ForwardRef as ReactComponent };